import { render, staticRenderFns } from "./SolidTile.vue?vue&type=template&id=28dcd877&scoped=true&functional=true"
import script from "./SolidTile.vue?vue&type=script&lang=ts"
export * from "./SolidTile.vue?vue&type=script&lang=ts"
import style0 from "./SolidTile.vue?vue&type=style&index=0&id=28dcd877&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "28dcd877",
  null
  
)

export default component.exports